import { IProductMeta } from "../models/product.ts";
import { IMultiOption } from "../models";

export const LIMIT = 10;

export const DEFAULT_META: IProductMeta = {
  total_items: 0,
  current_page: 1,
  current_limit: LIMIT,
  total: 0,
  page: 1,
  limit: LIMIT,
  has_more: false,
};

export const ALL_TIME_START_DATE = "2020-01-01";

export const PRODUCT_TYPES: IMultiOption[] = [
  { value: "hosted_courses", label: "Hosted Courses" },
  { value: "store", label: "Storefront" },
];

export const STOREFRONT_CATEGORIES: IMultiOption[] = [
  {
    label: "Digital Product",
    value: "digital_product",
  },
  {
    label: "Masterclass",
    value: "masterclass",
  },
  {
    label: "Webinar",
    value: "webinar",
  },
  {
    label: "Training",
    value: "training",
  },
  {
    label: "Events",
    value: "events",
  },
  {
    label: "Other",
    value: "other",
  },
];

export const feesSlug: Record<string, string> = {
  hosted_courses: "hosted-courses-pro-plan",
  store: "store-pro-plan",
};

export const SHARE_URLS: Record<string, string> = {
  facebook: "https://www.facebook.com/sharer/sharer.php?u=",
  telegram: "https://telegram.me/share/url?url=",
  twitter: "http://twitter.com/share?text=",
  whatsapp: "https://api.whatsapp.com/send?phone=&text=",
};
